import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Pages/Layout';
import Welcome from './Pages/Welcome';
import Project from './Pages/Project';
import Strategy from './Pages/Strategy';
import Design from './Pages/Design';
import Technology from './Pages/Technology';
import About from './Pages/About';
import DesignThinking from "./Pages/DesignThinking";
import TermsOfService from './Pages/TermsOfService';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import UxResearch from "./Pages/UxResearch";
import UxDesign from "./Pages/UxDesign";
import UiDesign from "./Pages/UiDesign";
import Contact from './Pages/Contact';
import Pricing from './Pages/Pricing';
import Error404 from './Pages/Error404';

import reportWebVitals from './reportWebVitals';
import './index.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Welcome />} />
          <Route path="projects" element= {<Project />} />
          <Route path="strategy" element= {<Strategy />} />
          <Route path="design" element= {<Design />} />
          <Route path="technology" element= {<Technology />} />
          <Route path="about" element= {<About />} />
          <Route path="contact" element= {<Contact />} />
          <Route path="design-thinking" element= {< DesignThinking />} />
          <Route path="ux-research" element= { < UxResearch />} />
          <Route path="ux-design" element= {< UxDesign /> } />
          <Route path="ui-design" element= {< UiDesign />} />
          <Route path="pricing" element= {< Pricing />} />
          <Route path="terms-of-service" element= {< TermsOfService />} />
          <Route path="privacy-policy" element= {< PrivacyPolicy />} />
          <Route path="*" element= {< Error404 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App></App>
  </React.StrictMode>
);
reportWebVitals();
